import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ClientDataService } from '@lib/client';
import { IDemandAddProductDataForm } from '../../../../../create/create-demand-product.service';
import { SubscriptionHelper } from '@lib/util';

@Component({
    selector: 'demand-product-data-input',
    templateUrl: './demand-add-product-data-input.component.html',
    styleUrls: ['./demand-add-product-data-input.component.scss'],
    standalone: false
})
export class DemandAddProductDataInputComponent extends SubscriptionHelper implements OnInit {
    private readonly clientDataService = inject(ClientDataService);
    private readonly cdr = inject(ChangeDetectorRef);

    @ViewChild('customerProductNumberInput', { static: false }) customerProductNumberInput?: ElementRef;

    @Input() public formGroup!: FormGroup<IDemandAddProductDataForm>;
    public defaultArticleNumber?: string;

    public nameMaxLength = 150;
    public articleNumberMaxLength = 50;
    public descriptionMaxLength = 10000;

    async ngOnInit(): Promise<void> {
        this.defaultArticleNumber = await this.clientDataService.getDefaultRfqArticleNumber().toPromise();
        this.formGroup.controls.requestUnit.valueChanges.subscribe((unit: string) => {
            if (unit) {
                this.formGroup.controls.contentUnit.setValue(unit);
            }
        });
    }

    public customerProductNumberIsKnownChanged(checked: boolean): void {
        this.cdr.detectChanges(); // detect that the #customerProductNumberInput input is perhaps now visible.
        this.updateCustomerProductNumberValidator(checked);
        if (checked && this.customerProductNumberInput) {
            this.customerProductNumberInput.nativeElement?.focus();
            this.customerProductNumberInput.nativeElement?.select();
        }
    }

    private updateCustomerProductNumberValidator(productNumberIsKnown: boolean): void {
        if (productNumberIsKnown) {
            this.formGroup.controls['customerProductNumber'].addValidators(Validators.required);
        } else {
            this.formGroup.controls['customerProductNumber'].removeValidators(Validators.required);
        }
        this.formGroup.controls['customerProductNumber'].updateValueAndValidity();
    }
}
